module.exports = __webpack_public_path__ + "static/menlo_park-79fa22453bc257d9071e80ec7eccdcea.jpg";